import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface OrderWriterServiceUrls {
    catalog: string;
    contract: string;
    sales: string;
    user: string;
    masterdata: string;
}

/**
 * Hosts of the OrderWriter Django services, called directly from the browser.
 *
 * Null when the build configuration sets no `ORDER_WRITER_SERVICES` (the base `environment.ts`). Consumers
 * must treat that as "OrderWriter Connect unavailable" rather than fall back to another environment's hosts,
 * since the Auth0 token is attached to every listed URL.
 */
export const orderWriterServiceUrls: OrderWriterServiceUrls | null =
    (environment as { ORDER_WRITER_SERVICES?: OrderWriterServiceUrls | null }).ORDER_WRITER_SERVICES ?? null;

export const ORDER_WRITER_SERVICE_URLS = new InjectionToken<OrderWriterServiceUrls>('ORDER_WRITER_SERVICE_URLS', {
    providedIn: 'root',
    factory: () => {
        if (!orderWriterServiceUrls) {
            throw new Error('OrderWriter Connect: ORDER_WRITER_SERVICES is not set for this build configuration');
        }
        return orderWriterServiceUrls;
    }
});
